import React, { useState } from 'react';
import { MOBILE_OPERATORS, COUNTRIES } from '../mock';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../hooks/use-toast';
import { Smartphone, Zap } from 'lucide-react';
import BrandImage from '../components/BrandImage';

const MobileTopup = () => {
  const [country, setCountry] = useState('US');
  const [operator, setOperator] = useState(MOBILE_OPERATORS[0]);
  const [phone, setPhone] = useState('');
  const [amount, setAmount] = useState(20);
  const { addItem } = useCart();
  const { toast } = useToast();
  const navigate = useNavigate();

  const operatorsForCountry = MOBILE_OPERATORS.filter(o => o.country === country);

  const handleTopup = () => {
    if (!phone || phone.length < 6) { toast({ title: 'Enter a valid phone number' }); return; }
    addItem({
      brandId: operator.id, brandName: `${operator.name} Refill`, brandSlug: operator.slug, brandDomain: operator.domain,
      brandLogo: `https://cdn.simpleicons.org/${operator.slug}/${operator.color.replace('#','')}`, brandColor: operator.color,
      denomination: amount, country: `${country} · ${phone}`, quantity: 1,
    });
    toast({ title: 'Refill added to cart' });
    navigate('/checkout');
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="font-display text-3xl md:text-4xl font-bold">Mobile Refill</h1>
        <p className="text-neutral-600 mt-2">Top up any prepaid phone in 180+ countries with crypto. Instant.</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        <div className="bg-white rounded-2xl border border-neutral-200 p-6 space-y-5">
          <div>
            <label className="text-sm font-semibold">Country</label>
            <div className="grid grid-cols-3 gap-2 mt-2">
              {COUNTRIES.slice(0, 6).map(c => (
                <button key={c.code} onClick={() => { setCountry(c.code); const op = MOBILE_OPERATORS.find(o => o.country === c.code); if (op) setOperator(op); }}
                  className={`p-3 rounded-lg border text-sm flex items-center gap-2 transition ${country === c.code ? 'border-[#8247E5] bg-violet-50' : 'border-neutral-200'}`}>
                  <span>{c.flag}</span> {c.code}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-sm font-semibold">Operator</label>
            <div className="grid grid-cols-2 gap-2 mt-2">
              {operatorsForCountry.length > 0 ? operatorsForCountry.map(o => (
                <button key={o.id} onClick={() => setOperator(o)}
                  className={`p-3 rounded-lg border flex items-center gap-2 transition ${operator.id === o.id ? 'border-[#8247E5] bg-violet-50' : 'border-neutral-200'}`}>
                  <BrandImage brand={o} className="w-8 h-8 rounded object-contain p-1" tileClassName="w-8 h-8 rounded text-[10px]" />
                  <span className="text-sm font-medium">{o.name}</span>
                </button>
              )) : <div className="col-span-2 text-sm text-neutral-500">No operators for this country yet.</div>}
            </div>
          </div>

          <div>
            <label className="text-sm font-semibold">Phone number</label>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+1 555 000 0000" className="mt-2 h-11" />
          </div>

          <div>
            <label className="text-sm font-semibold">Amount (USD)</label>
            <div className="grid grid-cols-4 gap-2 mt-2">
              {[10, 20, 30, 50].map(v => (
                <button key={v} onClick={() => setAmount(v)}
                  className={`h-12 rounded-lg border-2 font-semibold transition ${amount === v ? 'border-[#8247E5] bg-violet-50' : 'border-neutral-200'}`}>
                  ${v}
                </button>
              ))}
            </div>
          </div>

          <Button onClick={handleTopup} className="w-full h-12 bg-[#8247E5] hover:bg-[#6d33cc] text-white font-semibold">
            Top up ${amount}
          </Button>
        </div>

        <div>
          <div className="bg-gradient-to-br from-violet-50 to-fuchsia-50 rounded-2xl border border-violet-100 p-8">
            <Smartphone className="w-8 h-8 text-[#8247E5]" />
            <h3 className="font-display text-2xl font-bold mt-4">Refill in seconds</h3>
            <p className="text-neutral-700 mt-2 text-sm">Your phone credit arrives typically within 60 seconds of your crypto transaction being seen on the network.</p>
            <div className="mt-6 space-y-3 text-sm">
              <div className="flex items-center gap-2"><Zap className="w-4 h-4 text-[#8247E5]" /> Works with prepaid & postpaid</div>
              <div className="flex items-center gap-2"><Zap className="w-4 h-4 text-[#8247E5]" /> 500+ operators worldwide</div>
              <div className="flex items-center gap-2"><Zap className="w-4 h-4 text-[#8247E5]" /> Pay in BTC, ETH, USDT & more</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileTopup;
